module.exports = __webpack_public_path__ + "static/Redirection_Berlin_web-47f60ac31127563ae12203e18adcb0d2.mp4";